var Dodge = require('@antv/adjust/lib/dodge');

module.exports = Dodge;